import { Title } from "../../common/styles";
import { HeaderBlock, HeaderTitle, ListElement, StyledSection, Description } from "./styled";

const MorePage = () => {
    return (
        <>
            <HeaderBlock>
                <HeaderTitle>Дізнайся більше!</HeaderTitle>
            </HeaderBlock>
            <StyledSection>
                <article>
                    <Title>Як підготуватися до шугарингу?!</Title>
                    <ul>
                        <ListElement>
                            ✅️ Підготовка до шугарингу починається за тиждень-півтора до потрібної дати (якщо це після бритви&nbsp;🪒).
                            В цей час не слід голити волосся, воно повинно трохи відрости, щоб потім майстер міг його захопити цукрової пастою і видалити.
                            Рекомендована довжина волосся 5-7 мм. Це обов'язковий етап, оскільки від нього залежить результат після процедури ‼️
                        </ListElement>
                        <ListElement>
                            ✅️ Перед процедурою шкіра і волоски повинні бути знежиреними і сухими,
                            процесом підготовки займеться сам майстер, перед сеансом депіляції.
                        </ListElement>
                        <ListElement>
                            ✅️ Небажано засмагати за тиждень до процедури, не тільки на пляжі, але і в солярії&nbsp;🏖
                        </ListElement>
                        <ListElement>
                            ✅️ Не забудьте прийняти душ перед процедурою&nbsp;🛁
                        </ListElement>
                        <ListElement>
                            ✅️ Не наносьте креми і лосьйони, оскільки це може знизити ефективність шугарингу, через жирну плівку,
                            яка утворюється після застосування засобів.
                        </ListElement>
                        <ListElement>
                            ✅️ Прослідкуйте, щоб в зоні, де буде видалятися волосся, не було ранок і виразок,
                            інакше ви ризикуєте отримати сильне подразнення.
                        </ListElement>
                        <ListElement>
                            ✅️ Не відвідуйте сауну за день до процедури.
                        </ListElement>
                    </ul>
                    <Description>
                        Ось і все. Ніби нічого складного, а правил дотримуються не всі🙃 Не потрібно так.
                        Поважайте роботу майстра та його час😘
                    </Description>
                </article>
                <article>
                    <Title>Переваги шугарингу!</Title>
                    <Description>
                        До переваг ми можемо віднести:
                    </Description>
                    <ul>
                        <ListElement>
                            1️⃣ Відсутність побічних ефектів. З причини того, що паста не містить кислот,
                            барвників та ароматизаторів, до мінімуму зводиться можливість алергічних
                            реакцій та роздратування шкіри&nbsp;☘️<br />
                            Підвищена чутливість шкіри є протипоказанням для більшості методів депіляції, але не для шугарингу.
                        </ListElement>
                        <ListElement>
                            2️⃣ Мінімальна вірогідність отримання травми.
                            Внаслідок нагрівання цукрової пасти тільки до температури тіла,
                            виключається ймовірність термічних опіків, що трапляється, наприклад,
                            при видаленні волосся за допомогою воску.<br />
                            Правильне проведення методики шугарингу виключає також появу синяків та розривів на шкірі.
                            Паста, проникаючи у волосяні фолікули, м'яко обволікає волоски й витягає їх&nbsp;❣️
                        </ListElement>
                        <ListElement>
                            3️⃣ Шугаринг - це самий безболісний вид депіляції, що при використанні інших методик зустрічається украй рідко&nbsp;💃
                        </ListElement>
                        <ListElement>
                            4️⃣ Відбувається повне видалення небажаного волосяного покриву,
                            у тому числі зовсім маленьких волосків. Такого ефекту неможливо добитися при депіляції воском&nbsp;❤
                        </ListElement>
                        <ListElement>
                            5️⃣ Ефективне відлущення сприяє позбавленню від дорослих волосків,
                            а при правильному проведенні процедури та доглядом за шкірою після депіляції запобігає їх повторній появі&nbsp;🥰
                        </ListElement>
                        <ListElement>
                            6️⃣ Відсутня необхідність використання спеціальних хімічних препаратів для видалення суміші.
                            Цукрову пасту на відміну від деяких інших засобів для депіляції, можна легко змити водою&nbsp;🛁
                        </ListElement>
                        <ListElement>
                            7️⃣ Завдяки видаленню разом з волоссям також і волосяних цибулин, ріст волосся сповільнюється,
                            та впродовж не менше, чим трьох тижнів, зберігається ефект гладкої шкіри&nbsp;💃
                        </ListElement>
                    </ul>
                </article>
                <article>
                    <Title>Якими матеріалами я користуюсь?!</Title>
                    <Description>
                        Мій вибір впав на продукції української марки "Sugarlen" 🥰<br />
                        Продукція "Sugarlen" - це:
                    </Description>
                    <ul>
                        <ListElement>
                            🔷️ Висока якісь. Всі продукти Sugarlen регулярно перевіряється на якість перед тим як потрапити на ринок.
                            Щодня в студіях шугарингу сотні майстрів роблять свій вибір на цій продукції.
                        </ListElement>
                        <ListElement>
                            🔷️ Екологічність☘️ Продукція Sugarlen виготовляється на основі натуральних компонентів,
                            без токсинів, синиетики, шкідливих фарбників та ароматів.
                            Вся продукція сертифікована та відповідає нормам безпеки.
                        </ListElement>
                        <ListElement>
                            🔷️ Безпечність та надійність. Вся продукція 💯 відсотково гіпералергенна.
                            Паста складається тільки з безпечних та перевірених компонентах, як вода💦,
                            глюкоза, фруктоза 🍋 та інші, що підходять для будь-якого типу шкіри,
                            а спектр продукції дозволяє повністю попіклуватися про кожного з Вас&nbsp;😘🤗
                        </ListElement>
                    </ul>
                </article>
                <article>
                    <Title>Догляд за шкірою після процедури</Title>
                    <Description>
                        Всім відомо, що будь-який різновид епіляції – це справжній стрес для шкіри&nbsp;❤️‍🩹
                    </Description>
                    <ul>
                        <ListElement>
                            ❤️ Після висмикування волосків фолікули залишаються відкритими, а це означає, що будь-яка інфекція може потрапити в
                            організм і викликати роздратування або запалення&nbsp;😡
                        </ListElement>
                        <ListElement>
                            ❤️ Повноцінне відновлення дерми відбувається приблизно на 5-7 день. Саме в цей період слід особливо ретельно доглядати шкіру.
                            Якщо ви зробили депіляцію на певному місці тіла, необхідно обробляти його зволожувачами&nbsp;☘️&nbsp;💦
                        </ListElement>
                        <ListElement>
                            ❤️ Через 3-4 дні після депіляції цукром слід обробити потерпілі ділянки тіла скрабом.
                            Така нехитра процедура усуне ризик вростання волосся у верхні шари дерми.
                            Обробляти шкіру в такий спосіб можна 1 раз на тиждень. Рекомендується після шугарингу використовувати спеціальні засоби для догляду,
                            які припиняють ріст волосся&nbsp;😍
                        </ListElement>
                        <ListElement>
                            ❤️ Ділянки шкіри перші дні після шугарингу не повинні піддаватися тертю та іншим механічним впливам.
                            Особливо важливо це для зони бікіні та пахв. Перші дні слід виключити використання жорсткої мочалки.
                            2–3 дні до та після шугарингу, здійсненого на інтимній зоні, слід носити лише вільну білизну,
                            яка нещільно прилягає до шкіри. Важливо, щоб вона була виготовлена ​​тільки з натуральних матеріалів&nbsp;☘️
                        </ListElement>
                        <ListElement>
                            ❤️ Варто при депіляції пахв на кілька днів відмовитися від дезодоранту, інакше це може спричинити запалення.
                            Як альтернатива використовується косметичний тальк або дитяча посипка&nbsp;👶
                        </ListElement>
                        <ListElement>
                            ❤️ Протягом перших 2-3 діб після процедури заборонено засмагати у солярії або на сонці&nbsp;☀️
                        </ListElement>
                        <ListElement>
                            ❤️ З відкритими ділянками шкіри після депіляції просто не можна потрапляти на сонце.
                            Ультрафіолетові промені можуть спровокувати появу пігментних плям. Нерідко у зоні,
                            де проводився шугаринг, під сонячною дією з’являються алергічні висипання.
                        </ListElement>
                        <ListElement>
                            ❤️ У першу добу після процедури заборонено відвідувати басейн&nbsp;🏊‍♀️
                        </ListElement>
                        <ListElement>
                            ❤️ Також перші 2 доби після процедури шугарингу не рекомендується займатися спортом&nbsp;🏋‍♀️
                        </ListElement>
                    </ul>
                </article>
            </StyledSection>
        </>
    )
};

export default MorePage;